module.exports = __webpack_public_path__ + "media/svgs/TAFA20-Webseite_Pfeil-links_dropshadow_black-bf264a09c7e8e9f05e608218f4951bed.svg";